import { create, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

export interface LPWidgetProperties {
	realwidget: string;
	classes?: string[];
	name?: string;
	topicroot?: string;
	jsondata?: string;
}

const factory = create({ theme }).properties<LPWidgetProperties>();

export const LPWidget = factory(({ properties }) => {
	const { realwidget, name = '', jsondata } = properties();
	let params = {} as { [key: string]: any };
	if (jsondata) {
		params = JSON.parse(jsondata);
	}

	return w(realwidget, { key: name, ...params });
});

export default LPWidget;
